<template>
  <div class="order-item-product">
    <div class="order-item-product__name">
      {{ name }}
    </div>
    <div class="order-item-product__cost">
      Cost: {{ formatPrice(cost) }}
    </div>
    <div class="order-item-product__status">
      <button
        v-if="statusId == 'ACT'"
        class="btn btn-xs btn-accent-8 order-item-product__refund"
        aria-label="Open refund modal"
        @click="onRefundLineClick">
        {{ statusText }}
      </button>

      <span v-if="statusId == 'SUB'"
            class="order-item-product__status">
        {{ statusText }}
      </span>
    </div>

    <OrderLineRefundModal
      :show="showOrderLineRefundModal"
      :order-id="orderHeaderId"
      :credit-order-id="creditOrderId"
      :credit-order-line-id="creditOrderLineId"
      @close="showOrderLineRefundModal = false"
      @refreshPage="refreshPage">
    </OrderLineRefundModal>
  </div>
</template>

<script>
import { EcommerceModule } from "spiritweb.packages.ecommerce";
import OrderLineRefundModal from "~/Components/OrdersHistory/OrderLineRefundModal.vue";

export default {
  name: "OrderItemProduct",
  components: {
    OrderLineRefundModal
  },
  props: {
    orderHeaderId: {
      type: String,
      required: true
    },
    creditOrderId: {
      type: String,
      default: null
    },
    creditOrderLineId: {
      type: String,
      default: null
    },
    statusId: {
      type: String,
      default: null
    },
    statusText: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    cost: {
      type: Number,
      default: 0
    }
  },
  data: () => ( {
    showOrderLineRefundModal: false
  } ),
  methods: {
    formatPrice ( price ) {
      return EcommerceModule.renderPrice( price, "gbp", "en-gb" );
    },
    onRefundLineClick () {
      this.showOrderLineRefundModal = true;
    },
    refreshPage () {
      this.showOrderLineRefundModal = false;
      this.$emit( "refreshPage" );
    }
  }
};
</script>

<style lang="less" scoped>
.order-item-product {
  @media screen and (min-width: 768px) {
    padding-right: 30px;
  }

  &__name {
    font-weight: 600;
  }

  &__cost {
    color: red;
  }

  &__refund {
    margin-top: 2px;
    margin-bottom: 5px;
    padding: 2px 5px;
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
